import { Alert } from '@ps/sports-ui-component-library';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import useDisplayPriceChanges from '../../../../hooks/useDisplayPriceChanges';

import { TXTWCL_There_are_price_updates } from './PriceChangeAlert.messages.json';

export const PriceChangeAlert = () => {
  const { displayFooterPriceChanges } = useDisplayPriceChanges();
  const { formatMessage } = useRegulatoryIntl();

  if (!displayFooterPriceChanges) {
    return null;
  }

  return (
    <Alert
      level="update"
      variant="aggressive"
      aria-labelledby="betslip-price-change-alert"
      isSquare
      title={formatMessage(TXTWCL_There_are_price_updates)}
    />
  );
};
